import moment from "moment";

// "HH:mm:ss" (a SQL TIME string) -> whole seconds. 0 for falsy / unparseable.
export const hmsToSec = (t) => {
  if (!t) return 0;
  const [h, m, s] = String(t).split(":").map(Number);
  return (h || 0) * 3600 + (m || 0) * 60 + (s || 0);
};

// seconds -> "00h 00m" (zero-padded, matches the existing dashboard fmtHours output).
export const secToHhmm = (sec) => {
  const s = Math.max(0, Math.floor(sec || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return `${String(h).padStart(2, "0")}h ${String(m).padStart(2, "0")}m`;
};

// Live total break seconds: the closed breaks already summed on the server, plus the
// elapsed time of the still-open break (when breakStart is supplied for a member who is
// on a break right now). Without breakStart it degrades to the stored closed total.
export const liveBreakSeconds = (log, breakStart, now = moment()) => {
  const closed = hmsToSec(log.totalBreakDuration);
  if (!breakStart) return closed;
  return closed + Math.max(0, moment(now).diff(moment(breakStart), "seconds"));
};

// Live actual-worked seconds for an in-progress session. Returns null when the session is
// NOT live (closed, no check-in, or not today) — callers then fall back to the stored
// actualWorkingHour || workingHour. For office sessions the clock holds steady while on a
// break because (now - checkIn) and liveBreakSec advance together. Remote sessions don't
// deduct breaks (same rule as the server's recalculateSession), so their clock keeps
// running through lunch and lands on the value stored at sign-out.
export const liveActualSeconds = (log, liveBreakSec, now = moment()) => {
  if (log.checkout) return null; // session closed -> stored value is final
  if (!log.checkIn) return null; // no check-in -> nothing to run
  if (!moment(log.workDate).isSame(moment(now), "day")) return null; // only today's row is live
  const checkin = moment(
    `${moment(log.workDate).format("YYYY-MM-DD")} ${log.checkIn}`,
    "YYYY-MM-DD HH:mm:ss"
  );
  const elapsed = Math.max(0, moment(now).diff(checkin, "seconds"));
  const breakSec = log.workType === "REMOTE" ? 0 : liveBreakSec || 0;
  return Math.max(0, elapsed - breakSec);
};
